import { createModel } from "hox";
import React, { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdAppDetail, IMdAppFields } from "./AppTypes";
import { appService } from "./AppService";
import { ISelectOption } from "@src/components/YhFormBox/Types";
import { dictService } from "../base/dict/DictService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}


function useModel() {

    const initSearchParam: IMdAppFields = {};
    const initDataSource: IMdAppDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdAppFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdAppDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [resetState, setResetState] = useState(false)

    const [appTypeDs, setAppTypeDs] = useState<ISelectOption[]>()

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }

    /**
     * 加载选择项
     */
    const loadDs = async () => {
        let appTypes = await dictService.dictItemDs('app-type')
        setAppTypeDs(appTypes)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdAppFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    const loadData = async (page?: ISearchPage, searchValue: IMdAppFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await appService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const syncData = async () => {
        let ret = await appService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData()
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        resetState,
        appTypeDs,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        getSelectedRowData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        syncData,
        onSearch,
        onReset,
        loadDs,
    }

}


export const useAppModel = createModel(useModel);